import { ProductionFulfillmentApi, useAPIQuery } from "melco-shared-logic";

export const useSourceModifierDropdown = () => {
  return useAPIQuery(
    ProductionFulfillmentApi,
    ["sourceModifierDropdownData"],
    async (api) => {
      const response = await api.productionFulfillmentExceptionsGetList({});

      return response.list;
    },
    {
      queryOptions: {
        keepPreviousData: true,
      },
    }
  );
};
